import { datadogRum } from '@datadog/browser-rum';
import { getLogger } from '@/utils/logger/logger';

/**
 * Handles missing translation keys by logging an warn message and send an error log to POST:/frontend-logs
 * @param lngs - The list of languages.
 * @param ns - The namespace of the translation key.
 * @param key - The missing translation key.
 * @param fallbackValue - The fallback value for the missing translation key.
 */
export const missingKeyHandler = (lngs: readonly string[], ns: string, key: string, fallbackValue: string) => {
  const errorMessage = `Missing translation key: ${key} in namespace: ${ns} for language: ${lngs}, fallback value: ${fallbackValue}`;
  // eslint-disable-next-line no-console
  console.error(errorMessage);
  const missingTranslationError = new Error(errorMessage);
  missingTranslationError.name = 'MISSING_TRANSLATION';

  // Send error log to Datadog using addError
  datadogRum.addError(missingTranslationError, { key, ns, lngs, fallbackValue });
  // Send error log to /frontend-logs
  getLogger('MISSING_TRANSLATION').error(errorMessage);
};
